import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 36,
    fontFamily: 'Noto Sans',
    fontSize: 10,
  },

  /* ================= HEADER ================= */
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 30,
  },
  headerNoCompany: {
    justifyContent: 'flex-end',
  },

  leftHeader: {
    flexDirection: 'column',
    width: '58%',
    paddingRight: 12,
  },

  logo: {
    width: 100,
    height: 100,
    marginBottom: 8,
    objectFit: 'contain',
  },

  companyName: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#000000',
    marginBottom: 5,
  },

  companyAddress: {
    fontSize: 10,
    color: '#444444',
    lineHeight: 1.4,
  },

  rightHeader: {
    alignItems: 'flex-end',
    width: '40%',
  },
  rightHeaderNoCompany: {
    width: '100%',
  },

  invoiceTitle: {
    fontSize: 20,
    color: '#000000',
    marginBottom: 4,
    fontWeight: 400,
    textAlign: 'right',
  },

  individualNameHeader: {
    fontSize: 22,
    color: '#000000',
    textTransform: 'uppercase',
    marginBottom: 8,
    textAlign: 'right',
  },

  invoiceNumber: {
    fontSize: 12,
    color: '#000000',
    marginBottom: 6,
    fontWeight: 400,
  },

  balanceDueLabel: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#000000',
    marginTop: 4,
  },

  balanceDueAmount: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#000000',
    marginTop: 5,
  },

  /* ================= DETAILS ================= */
  detailsSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 30,
  },

  billToSection: {
    width: '60%',
  },

  sectionTitle: {
    fontSize: 10,
    color: '#000000',
    marginBottom: 4,
  },

  customerName: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#000000',
    marginBottom: 4,
  },

  addressLine: {
    fontSize: 10,
    color: '#000000',
    marginBottom: 2,
  },

  placeOfSupplyRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 6,
  },

  placeOfSupplyLabel: {
    fontSize: 10,
    color: '#000000',
    fontWeight: 'semibold',
    width: 90,
  },

  placeOfSupplyValue: {
    fontSize: 10,
    color: '#000000',
    flex: 1,
    lineHeight: 1.4,
  },

  invoiceInfoSection: {
    width: '35%',
    alignItems: 'flex-end',
  },

  infoRow: {
    flexDirection: 'row',
    marginBottom: 5,
  },

  infoLabel: {
    fontSize: 10,
    color: '#000000',
    width: 120,
    textAlign: 'right',
    marginRight: 10,
    fontWeight: 'semibold',
  },

  infoValue: {
    fontSize: 10,
    color: '#000000',
    width: 80,
    textAlign: 'right',
  },

  /* ================= TABLE ================= */
  table: {
    marginBottom: 20,
  },

  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#333333',
    color: '#FFFFFF',
    fontSize: 10,
    paddingVertical: 8,
  },

  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5E5',
    paddingVertical: 8,
    fontSize: 10,
  },

  colIndex: {
    width: '8%',
    paddingHorizontal: 6,
  },

  colDescription: {
    width: '30%',
    paddingHorizontal: 6,
  },

  colHsn: {
    width: '12%',
    paddingHorizontal: 6,
    textAlign: 'center',
  },

  colQuantity: {
    width: '10%',
    paddingHorizontal: 6,
    textAlign: 'center',
  },

  colRate: {
    width: '12%',
    paddingHorizontal: 6,
    textAlign: 'center',
  },

  colTaxRate: {
    width: '10%',
    paddingHorizontal: 6,
    textAlign: 'center',
  },

  taxSplit: {
    fontSize: 7,
    color: '#666666',
    marginTop: 1,
  },

  colAmount: {
    width: '18%',
    paddingHorizontal: 6,
    textAlign: 'right',
  },

  descriptionDetail: {
    fontSize: 9,
    color: '#444444',
    marginTop: 2,
    fontStyle: 'italic',
  },

  /* ================= SUMMARY ================= */
  summarySection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },

  /* LEFT — PAYMENT INFO */
  bankDetails: {
    width: '48%',
  },

  bankTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#000000',
    marginBottom: 10,
    textDecoration: 'underline',
    textunderlineOffset: '8px',
  },

  bankInfoRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 5,
  },

  bankLabel: {
    fontSize: 10,
    color: '#000000',
    width: 90,
    marginRight: 6,
  },

  bankValue: {
    fontSize: 10,
    color: '#000000',
    fontWeight: 'semibold',
    flex: 1,
    flexShrink: 1,
    lineHeight: 1.4,
  },

  /* RIGHT — TOTALS */
  totalsSection: {
    width: '48%',
    alignItems: 'flex-end',
  },

  totalsContainer: {
    width: 200,
  },

  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 4,
  },

  totalLabel: {
    fontSize: 10,
    color: '#444444',
  },

  totalValue: {
    fontSize: 10,
    color: '#000000',
  },

  grandTotalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#F3F3F3',
    paddingVertical: 6,
    paddingHorizontal: 8,
    marginTop: 6,
  },

  grandTotalLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#000000',
  },

  grandTotalValue: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#000000',
  },

  amountInWords: {
    fontSize: 9,
    color: '#444444',
    marginTop: 6,
  },

  amountInWordsValue: {
    fontStyle: 'italic',
    color: '#000000',
  },

  balanceDueContainer: {
    alignItems: 'flex-end',
    marginTop: 10,
  },

  tableRowAlt: {
    backgroundColor: '#FAFAFA',
  },
  poweredBy: {
    fontSize: 9,
    color: '#f0954b',
    textDecoration: 'underline',
    marginTop: 4,
  },

  itemName: {
    fontSize: 10,
    fontWeight: 'semibold',
    color: '#000000',
    marginBottom: 2,
  },

  monoValue: {
    fontFamily: 'Courier',
    letterSpacing: 0.5,
  },

  /* ================= FOOTER ================= */
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 36,
    right: 36,
    textAlign: 'center',
    fontSize: 9,
    color: '#999999',
    borderTopWidth: 1,
    borderTopColor: '#E5E5E5',
    paddingTop: 8,
  },

  taxNote: {
    fontSize: 9,
    color: '#666666',
    fontStyle: 'italic',
    lineHeight: 1.4,
    marginTop: 6,
  },
});
